import React, { useState } from 'react';

import classes from './AddIngredientModal.module.scss';
import { LbBigModal } from '../../../../../shared/components/modals';
import {
  LbTabPanel,
  LbTabs,
  LbToggleTabsList,
  TabOption,
  TabsConfig,
} from '../../../../../shared/components/tabs';
import { DatabaseFoodItem } from '../../../../interfaces/DatabaseFoodItem';
import { FoodListItem } from '../../../../interfaces/FoodListItem';
import {
  INGREDIENT_SEARCH_TAB,
  IngredientSearchTab,
} from './constants/ingredientSearchTabs';
import { IngredientSearchTabPanel } from './IngredientSearchTabPanel/IngredientSearchTabPanel';

const ingredientSearchTabs: TabOption<IngredientSearchTab>[] = [
  { value: INGREDIENT_SEARCH_TAB.CORE, label: 'Core Food' },
  { value: INGREDIENT_SEARCH_TAB.SUPPLEMENT, label: 'Supplements' },
  { value: INGREDIENT_SEARCH_TAB.VEGGIES, label: 'Veggies' },
  { value: INGREDIENT_SEARCH_TAB.NUTRITIONIX, label: 'Nutritionix' },
];

type AddIngredientModalProps = {
  /** the modal stays open - the caller closes it */
  onFoodSelect: (food: FoodListItem | DatabaseFoodItem) => void;
  onClose: () => void;
};

/** Mount it only while open - the first page of the Core tab is fetched on mount */
const AddIngredientModal = ({ onFoodSelect, onClose }: AddIngredientModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const tabsConfig: TabsConfig<IngredientSearchTab>[] = ingredientSearchTabs.map(
    (tab) => ({
      ...tab,
      panel: (
        <IngredientSearchTabPanel
          tab={tab.value}
          onFoodSelect={onFoodSelect}
          onLoadingChange={setIsLoading}
        />
      ),
    }),
  );

  return (
    <LbBigModal
      open
      title="Add Ingredient"
      isLoading={isLoading}
      withScrollBox={false}
      onClose={onClose}
      buttonOptions={{
        noHandler: onClose,
        noText: 'Close',
        yesVisible: false,
      }}
    >
      <LbTabs
        defaultValue={INGREDIENT_SEARCH_TAB.CORE}
        data-test-id="ingredient-search-tabs"
      >
        <LbToggleTabsList
          fullWidth
          tabsConfig={tabsConfig}
          className={classes.tabsList}
          size="small"
        />
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </LbBigModal>
  );
};

export { AddIngredientModal };
